module.exports = __webpack_public_path__ + "assets/img/f39f15d41b34d7381219cec3cc509b10.svg";